import React from 'react'
import Icon from './icon'

export type ChipProps = {
  size?: 'sm' | 'md'
  label: string
  onClose?: () => void
}

export const Chip: React.FC<ChipProps> = ({
  size = 'md',
  label,
  onClose = undefined,
}) => (
  <div
    className={`text-${size} bg-primary-50 border-primary border rounded-full py-2 px-3 flex flex-nowrap items-center gap-2`}
  >
    <div className="flex text-sm font-medium break-normal flex-nowrap">
      {label}
    </div>
    {onClose && (
      <button type="button" onClick={() => onClose()} aria-label="close">
        <Icon icon="close" className="w-4 h-4" color="primary" />
      </button>
    )}
  </div>
)
